import { FC } from 'react';
import { EdgeProps, EdgeLabelRenderer, BaseEdge, getBezierPath } from 'reactflow';
import { NodeContent } from '../nodeTypes/common';
import clsx from 'clsx';

const Bezier: FC<EdgeProps> = (props: EdgeProps) => {
    const {
        id,
        sourceX,
        sourceY,
        targetX,
        targetY,
        sourcePosition,
        targetPosition,
        data,
        ...rest
    } = props;

    const [edgePath, labelX, labelY] = getBezierPath({
        sourceX,
        sourceY,
        sourcePosition,
        targetX,
        targetY,
        targetPosition,
    });

    const edgeWidth = Math.abs(targetX - sourceX);
    const maxContentWidth = edgeWidth >= 64 ? edgeWidth - 32 : 120; // Horizontal connection: width - 32px padding, Vertical connection: 120px (average node width)

    return (
        <>
            <BaseEdge id={id} path={edgePath} {...rest} />
            <EdgeLabelRenderer>
                <div
                    style={{
                        position: 'absolute',
                        transform: `translate(-50%, -50%) translate(${labelX}px,${labelY}px)`,
                        maxWidth: maxContentWidth,
                        ...rest.style,
                    }}
                    className={clsx("FlowChart-edge-label-content", "nodrag", "nopan", data?.className)}
                >
                    <NodeContent {...props} />
                </div>
            </EdgeLabelRenderer>
        </>
    );
};

export { Bezier };
